export const validateEmail = (email) => {
    if (!email?.trim()) {
        return 'Email is required';
    }
    
    const emailTrimmed = email.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(emailTrimmed)) {
        return 'Please enter a valid email address';
    }
    
    if (emailTrimmed.length > 254) {
        return 'Email address is too long';
    }
    
    return null;
};

export const validatePassword = (password, options = {}) => {
    const { 
        requireComplexity = true, 
        minLength = 8, 
        maxLength = 128 
    } = options;
    
    if (!password?.trim()) {
        return 'Password is required';
    }
    
    if (!requireComplexity) {
        // Simple validation for login
        if (password.length < minLength) {
            return `Password must be at least ${minLength} characters`;
        }
        if (password.length > maxLength) {
            return `Password must be no more than ${maxLength} characters`;
        }
        return null;
    }
    
    const passwordErrors = [];
    
    if (password.length < minLength) {
        passwordErrors.push(`at least ${minLength} characters`);
    }
    if (password.length > maxLength) {
        passwordErrors.push(`no more than ${maxLength} characters`);
    }
    if (!/[a-z]/.test(password)) {
        passwordErrors.push('one lowercase letter');
    }
    if (!/[A-Z]/.test(password)) {
        passwordErrors.push('one uppercase letter');
    }
    if (!/\d/.test(password)) {
        passwordErrors.push('one number');
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        passwordErrors.push('one special character');
    }
    
    if (passwordErrors.length > 0) {
        return `Password must contain:\n${passwordErrors.join(', ')}`;
    }
    
    return null;
};

export const validatePasswordConfirmation = (password, confirmPassword) => {
    if (!confirmPassword?.trim()) {
        return 'Please confirm your password';
    }
    
    if (password !== confirmPassword) {
        return 'Passwords do not match';
    }
    
    return null;
};

export const validateName = (name, fieldName = 'Name') => {
    if (!name?.trim()) {
        return `${fieldName} is required`;
    }
    
    if (name.trim().length < 2) {
        return `${fieldName} must be at least 2 characters`;
    }
    
    if (name.trim().length > 50) {
        return `${fieldName} must be no more than 50 characters`;
    }
    
    return null;
};

export const validateLoginForm = (email, password) => {
    const errors = {};
    
    const emailError = validateEmail(email);
    if (emailError) errors.email = emailError;
    
    const passwordError = validatePassword(password, { requireComplexity: false });
    if (passwordError) errors.password = passwordError;
    
    return {
        errors,
        isValid: Object.keys(errors).length === 0
    };
};

export const validateRegisterForm = (name, email, password) => {
    const errors = {};
    
    const emailError = validateEmail(email);
    if (emailError) errors.email = emailError;
    
    const passwordError = validatePassword(password, { requireComplexity: true });
    if (passwordError) errors.password = passwordError;
    
    if (name !== undefined) {
        const nameError = validateName(name, 'Name');
        if (nameError) errors.name = nameError;
    }
    
    return {
        errors,
        isValid: Object.keys(errors).length === 0
    };
};

export const validateChangePasswordForm = (currentPassword, newPassword) => {
    const errors = {};
    
    if (!currentPassword?.trim()) {
        errors.currentPassword = 'Current password is required';
    }
    
    const newPasswordError = validatePassword(newPassword, { requireComplexity: true });
    if (newPasswordError) errors.newPassword = newPasswordError;
    
    if (currentPassword && newPassword && currentPassword === newPassword) {
        errors.newPassword = 'New password must be different from current password';
    }
    
    return {
        errors,
        isValid: Object.keys(errors).length === 0
    };
};
